import { createContext, useContext, useEffect, useState } from "react";

const it = {
  nav: { auto: "Auto", servizi: "Servizi", showroom: "Showroom", contatti: "Contatti" },
  hero: {
    eyebrow: "YOUCARS S.R.L. — Lecco, Italia", l1: "L'auto giusta,", em: "ovunque", l2: " tu", l3: "sia in Europa.",
    sub: "Veicoli selezionati e verificati nel nostro showroom di Lecco. Consegna in tutta Europa, isole comprese, con formula soddisfatti o rimborsati.",
    cta: "Scopri le auto", cta2: "Vieni in sede", caption: "Showroom · Lecco", badge: "SODDISFATTI O RIMBORSATI · EUROPA ·",
    stats: [["Spedizione", "Tutta Europa, isole comprese"], ["Garanzia", "Soddisfatti o rimborsati"], ["Pagamenti", "Anche in criptovalute"]],
  },
  marquee: ["Spedizione in tutta Europa", "Isole comprese", "Soddisfatti o rimborsati", "Pagamenti in criptovalute", "Showroom a Lecco", "Auto verificate"],
  inv: {
    eyebrow: "01 — Auto disponibili", t1: "In vetrina", em: "adesso", search: "Cerca marca, modello…",
    sorts: { recenti: "Più recenti", "prezzo-asc": "Prezzo crescente", "prezzo-desc": "Prezzo decrescente" },
    emptyNone: "Nuovi arrivi in preparazione.", emptyNoMatch: "Nessuna auto corrisponde alla ricerca.",
    emptySub: "Cerchi un modello specifico? Lo troviamo noi per te.", emptyCta: "Scrivici su WhatsApp", emptyMsg: "Buongiorno, sto cercando un'auto specifica.",
    fuel: "Carburante", all: "Tutti", price: "Fascia di prezzo", year: "Anno dal", anyYear: "Qualsiasi", reset: "Azzera filtri", results: (n) => `${n} ${n === 1 ? "auto" : "auto"}`, filters: "Filtri",
  },
  card: { sold: "Venduta", photos: "foto", fallback: "Veicolo disponibile" },
  svc: {
    eyebrow: "02 — Perché YOUCARS", t1: "Comprare un'auto,", em: "senza pensieri.", ship1: "Spedizione in tutta Europa,", ship2: "isole comprese.",
    shipTxt: "Dalla Sicilia alla Sardegna, dalle Baleari alla Scandinavia: consegniamo la tua auto direttamente a destinazione.",
    refundLabel: "Formula", refundT: "Soddisfatti o rimborsati", refundTxt: "Acquisti con la massima serenità.",
    cryptoLabel: "Pagamenti", cryptoT: "Accettiamo criptovalute", cryptoTxt: "Per info sul pagamento in cripto parla con noi in sede.",
    showroomT: "Showroom, sede legale e operativa in un unico indirizzo:",
  },
  show: {
    eyebrow: "03 — Lo showroom", t1: "Vieni a vederla", em: "dal vivo.",
    txt: "Ogni auto esposta è selezionata e controllata. Nel nostro showroom di Lecco puoi vederla, provarla e parlare con noi di permute, finanziamenti e pagamenti in criptovalute.",
    stat1: "Consegna in tutta Europa", stat2: "Soddisfatti o rimborsati",
  },
  contact: {
    eyebrow: "04 — Contatti", t1: "Parliamo della", em: "tua prossima auto.", showroom: "Showroom", directions: "Indicazioni stradali",
    legal: ["Ragione Sociale", "Sede Legale", "Sede Operativa", "Partita IVA", "Codice Fiscale", "Codice REA"],
  },
  btn: { wa: "WhatsApp", call: "Chiama", email: "Email", waDefault: "Buongiorno YOUCARS, vorrei informazioni.", mailDefault: "Richiesta informazioni" },
  footer: {
    desc: "Concessionaria auto a Lecco. Spedizione in tutta Europa, isole comprese, con formula soddisfatti o rimborsati. Accettiamo pagamenti in criptovalute: info in sede.",
    company: "Dati societari", contacts: "Contatti", seat: "Sede Legale e Operativa", admin: "Area riservata",
  },
  detail: {
    back: "Tutte le auto", notFound: "Auto non trovata", backHome: "Torna alle auto", desc: "Descrizione",
    perks: ["Spedizione in tutta Europa, isole comprese", "Formula soddisfatti o rimborsati", "Pagamento anche in criptovalute — info in sede"],
    interest: "Buongiorno YOUCARS, sono interessato a:", subject: "Richiesta info:",
    fields: { marca: "Marca", modello: "Modello", anno: "Anno", km: "Chilometri", colore: "Colore", carburante: "Carburante", cambio: "Cambio", potenza: "Potenza", targa: "Targa", telaio: "N° Telaio" },
  },
  values: {},
};

const en = {
  nav: { auto: "Cars", servizi: "Services", showroom: "Showroom", contatti: "Contact" },
  hero: {
    eyebrow: "YOUCARS S.R.L. — Lecco, Italy", l1: "The right car,", em: "wherever", l2: " you", l3: "are in Europe.",
    sub: "Hand-picked, inspected vehicles from our showroom in Lecco. Delivery anywhere in Europe, islands included, with a satisfied-or-refunded guarantee.",
    cta: "Browse cars", cta2: "Visit us", caption: "Showroom · Lecco", badge: "SATISFIED OR REFUNDED · EUROPE ·",
    stats: [["Shipping", "All of Europe, islands included"], ["Guarantee", "Satisfied or refunded"], ["Payments", "Crypto accepted too"]],
  },
  marquee: ["Shipping across Europe", "Islands included", "Satisfied or refunded", "Crypto payments", "Showroom in Lecco", "Inspected cars"],
  inv: {
    eyebrow: "01 — Available cars", t1: "On display", em: "now", search: "Search make, model…",
    sorts: { recenti: "Newest", "prezzo-asc": "Price: low to high", "prezzo-desc": "Price: high to low" },
    emptyNone: "New arrivals coming soon.", emptyNoMatch: "No cars match your search.",
    emptySub: "Looking for a specific model? We'll find it for you.", emptyCta: "Message us on WhatsApp", emptyMsg: "Hello, I'm looking for a specific car.",
    fuel: "Fuel", all: "All", price: "Price range", year: "Year from", anyYear: "Any", reset: "Reset filters", results: (n) => `${n} ${n === 1 ? "car" : "cars"}`, filters: "Filters",
  },
  card: { sold: "Sold", photos: "photos", fallback: "Available vehicle" },
  svc: {
    eyebrow: "02 — Why YOUCARS", t1: "Buying a car,", em: "worry-free.", ship1: "Shipping across Europe,", ship2: "islands included.",
    shipTxt: "From Sicily to Sardinia, from the Balearics to Scandinavia: we deliver your car right to your door.",
    refundLabel: "Guarantee", refundT: "Satisfied or refunded", refundTxt: "Buy with complete peace of mind.",
    cryptoLabel: "Payments", cryptoT: "We accept crypto", cryptoTxt: "For crypto payment details, talk to us at the showroom.",
    showroomT: "Showroom, registered and operational office at one address:",
  },
  show: {
    eyebrow: "03 — The showroom", t1: "Come see it", em: "in person.",
    txt: "Every car on display is selected and inspected. At our Lecco showroom you can see it, test drive it and talk to us about trade-ins, financing and crypto payments.",
    stat1: "Delivery across Europe", stat2: "Satisfied or refunded",
  },
  contact: {
    eyebrow: "04 — Contact", t1: "Let's talk about", em: "your next car.", showroom: "Showroom", directions: "Get directions",
    legal: ["Company name", "Registered office", "Operational office", "VAT number", "Tax code", "REA number"],
  },
  btn: { wa: "WhatsApp", call: "Call", email: "Email", waDefault: "Hello YOUCARS, I'd like some information.", mailDefault: "Information request" },
  footer: {
    desc: "Car dealership in Lecco, Italy. Shipping across Europe, islands included, with a satisfied-or-refunded guarantee. We accept crypto payments: details at the showroom.",
    company: "Company details", contacts: "Contact", seat: "Registered & operational office", admin: "Admin area",
  },
  detail: {
    back: "All cars", notFound: "Car not found", backHome: "Back to cars", desc: "Description",
    perks: ["Shipping across Europe, islands included", "Satisfied-or-refunded guarantee", "Crypto payments accepted — details at the showroom"],
    interest: "Hello YOUCARS, I'm interested in:", subject: "Information request:",
    fields: { marca: "Make", modello: "Model", anno: "Year", km: "Mileage", colore: "Colour", carburante: "Fuel", cambio: "Gearbox", potenza: "Power", targa: "Plate", telaio: "VIN" },
  },
  values: { benzina: "Petrol", diesel: "Diesel", ibrida: "Hybrid", elettrica: "Electric", gpl: "LPG", metano: "CNG", manuale: "Manual", automatico: "Automatic" },
};

const de = {
  nav: { auto: "Autos", servizi: "Service", showroom: "Showroom", contatti: "Kontakt" },
  hero: {
    eyebrow: "YOUCARS S.R.L. — Lecco, Italien", l1: "Dein Auto,", em: "überall", l2: " in", l3: "Europa.",
    sub: "Ausgewählte, geprüfte Fahrzeuge aus unserem Showroom in Lecco. Lieferung in ganz Europa, inklusive Inseln, mit Geld-zurück-Garantie.",
    cta: "Autos entdecken", cta2: "Besuch uns", caption: "Showroom · Lecco", badge: "ZUFRIEDEN ODER GELD ZURÜCK · EUROPA ·",
    stats: [["Versand", "Ganz Europa, inkl. Inseln"], ["Garantie", "Zufrieden oder Geld zurück"], ["Zahlung", "Auch in Kryptowährungen"]],
  },
  marquee: ["Versand in ganz Europa", "Inseln inklusive", "Zufrieden oder Geld zurück", "Zahlung in Krypto", "Showroom in Lecco", "Geprüfte Autos"],
  inv: {
    eyebrow: "01 — Verfügbare Autos", t1: "Jetzt im", em: "Showroom", search: "Marke, Modell suchen…",
    sorts: { recenti: "Neueste", "prezzo-asc": "Preis aufsteigend", "prezzo-desc": "Preis absteigend" },
    emptyNone: "Neue Fahrzeuge in Vorbereitung.", emptyNoMatch: "Kein Auto entspricht deiner Suche.",
    emptySub: "Suchst du ein bestimmtes Modell? Wir finden es für dich.", emptyCta: "Schreib uns auf WhatsApp", emptyMsg: "Hallo, ich suche ein bestimmtes Auto.",
    fuel: "Kraftstoff", all: "Alle", price: "Preisspanne", year: "Baujahr ab", anyYear: "Beliebig", reset: "Filter zurücksetzen", results: (n) => `${n} ${n === 1 ? "Auto" : "Autos"}`, filters: "Filter",
  },
  card: { sold: "Verkauft", photos: "Fotos", fallback: "Verfügbares Fahrzeug" },
  svc: {
    eyebrow: "02 — Warum YOUCARS", t1: "Autokauf,", em: "ganz entspannt.", ship1: "Versand in ganz Europa,", ship2: "Inseln inklusive.",
    shipTxt: "Von Sizilien bis Sardinien, von den Balearen bis Skandinavien: Wir liefern dein Auto direkt ans Ziel.",
    refundLabel: "Garantie", refundT: "Zufrieden oder Geld zurück", refundTxt: "Kaufe mit voller Sicherheit.",
    cryptoLabel: "Zahlung", cryptoT: "Wir akzeptieren Krypto", cryptoTxt: "Infos zur Krypto-Zahlung erhältst du bei uns vor Ort.",
    showroomT: "Showroom, Rechts- und Betriebssitz an einer Adresse:",
  },
  show: {
    eyebrow: "03 — Der Showroom", t1: "Komm vorbei,", em: "live erleben.",
    txt: "Jedes ausgestellte Auto ist ausgewählt und geprüft. In unserem Showroom in Lecco kannst du es ansehen, Probe fahren und mit uns über Inzahlungnahme, Finanzierung und Krypto-Zahlung sprechen.",
    stat1: "Lieferung in ganz Europa", stat2: "Zufrieden oder Geld zurück",
  },
  contact: {
    eyebrow: "04 — Kontakt", t1: "Sprechen wir über", em: "dein nächstes Auto.", showroom: "Showroom", directions: "Route planen",
    legal: ["Firmenname", "Rechtssitz", "Betriebssitz", "USt-IdNr.", "Steuernummer", "REA-Nummer"],
  },
  btn: { wa: "WhatsApp", call: "Anrufen", email: "E-Mail", waDefault: "Hallo YOUCARS, ich hätte gerne Informationen.", mailDefault: "Informationsanfrage" },
  footer: {
    desc: "Autohaus in Lecco, Italien. Versand in ganz Europa, inklusive Inseln, mit Geld-zurück-Garantie. Wir akzeptieren Krypto-Zahlungen: Infos vor Ort.",
    company: "Firmendaten", contacts: "Kontakt", seat: "Rechts- und Betriebssitz", admin: "Admin-Bereich",
  },
  detail: {
    back: "Alle Autos", notFound: "Auto nicht gefunden", backHome: "Zurück zu den Autos", desc: "Beschreibung",
    perks: ["Versand in ganz Europa, inkl. Inseln", "Zufrieden oder Geld zurück", "Zahlung auch in Krypto — Infos vor Ort"],
    interest: "Hallo YOUCARS, ich interessiere mich für:", subject: "Anfrage:",
    fields: { marca: "Marke", modello: "Modell", anno: "Baujahr", km: "Kilometerstand", colore: "Farbe", carburante: "Kraftstoff", cambio: "Getriebe", potenza: "Leistung", targa: "Kennzeichen", telaio: "FIN" },
  },
  values: { benzina: "Benzin", diesel: "Diesel", ibrida: "Hybrid", elettrica: "Elektro", gpl: "Autogas (LPG)", metano: "Erdgas (CNG)", manuale: "Schaltgetriebe", automatico: "Automatik" },
};

export const LANGS = { it, en, de };
const KEY = "youcars_lang";
const initial = () => {
  const saved = localStorage.getItem(KEY);
  if (saved && LANGS[saved]) return saved;
  const nav = (navigator.language || "it").slice(0, 2);
  return LANGS[nav] ? nav : "it";
};

const Ctx = createContext({ lang: "it", setLang: () => {}, t: it });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(initial);
  useEffect(() => {
    localStorage.setItem(KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <Ctx.Provider value={{ lang, setLang, t: LANGS[lang] }}>{children}</Ctx.Provider>;
};

export const useLang = () => useContext(Ctx);
export const useT = () => useContext(Ctx).t;

export const tv = (t, v) => (typeof v === "string" ? t.values[v.trim().toLowerCase()] ?? v : v);
